(function (angular) {
	'use strict';

	angular
		.module('PinMeTo.directives')
		.service('pmtLightBoxBodyClassesService', function () {
			var classes = [];
			this.onAdd = function () {};
			this.onRemove = function () {};

			this.resetClasses = function () {
				classes.forEach(x => this.onRemove(x));
				classes = [];
			};
			this.addClass = function (c) {
				var index = classes.indexOf(c);
				if (index === -1) {
					classes.push(c);
					this.onAdd(c);
				}
			};

			this.removeClass = function (c) {
				var index = classes.indexOf(c);
				if (index !== -1) {
					classes.splice(index, 1);
					this.onRemove(c);
				}
			};
		})

		.directive('pmtLightBoxBodyClasses', [
			'$timeout',
			'pmtLightBoxBodyClassesService',
			function ($timeout, bodyClassesService) {
				return {
					restrict: 'A',
					link: function (scope, element) {
						element.addClass('pmt-lightbox');

						bodyClassesService.onAdd = function (c) {
							$timeout(function () {
								element.addClass(c);
							}, 0);
						};
						bodyClassesService.onRemove = function (c) {
							$timeout(function () {
								element.removeClass(c);
							}, 0);
						};
					}
				};
			}
		])

		.directive('pmtLightBox', [
			'pmtLightBoxBodyClassesService',
			function (bodyClassesService) {
				return {
					restrict: 'A',
					replace: true,
					transclude: true,
					scope: {
						pmtLightBox: '=',
						noClose: '@',
						noCloseOnBackground: '=?',
						alertStyle: '@',
						close: '&?',
						additionalSpace: '@'
					},
					link: function (scope, element, attrs) {
						scope.openAcceptFlag = false;
						scope.userAllowedToClose = true;

						var openAccept = function () {
							scope.openAcceptFlag = true;
							bodyClassesService.addClass('pmt-lightbox--active');
						};

						var _close = function () {
							if (scope.close && scope.pmtLightBox) {
								scope.close();
							}
							scope.openAcceptFlag = false;
							scope.pmtLightBox = false;
							bodyClassesService.removeClass('pmt-lightbox--active');
						};

						scope.closeAccept = function ($event) {
							_close();
						};

						scope.listenToClicks = function ($event) {
							if (
								scope.noCloseOnBackground !== true &&
								scope.userAllowedToClose &&
								$event.target.classList[0] === 'pmt-lightbox__container'
							) {
								_close();
							}
						};

						scope.$on('pmtViewKeyUp', function (event, keyCode) {
							if (keyCode === 27 && scope.userAllowedToClose) {
								_close();
							}
						});

						attrs.$observe('noClose', function (newVal, oldVal) {
							if (newVal === oldVal) {
								return;
							}
							if (newVal) {
								scope.userAllowedToClose = false;
							} else {
								scope.userAllowedToClose = true;
							}
						});

						if (scope.pmtLightBox) {
							openAccept();
						}

						scope.$watch('pmtLightBox', function (newVal, oldVal) {
							if (newVal === oldVal) {
								return;
							}
							if (newVal) {
								openAccept();
							} else {
								_close();
							}
						});
					},
					templateUrl: 'pmtShared/directives/pmt-light-box.html'
				};
			}
		]);
})(window.angular);
